import { useEffect, useRef } from 'react';

const APP_NAME = 'iKompete';

/** "<title> · iKompete", or just "iKompete" when there is no title (yet). */
export function formatDocumentTitle(title?: string | null): string {
  return title ? `${title} · ${APP_NAME}` : APP_NAME;
}

/**
 * Sets the browser tab title while the calling component is mounted and
 * restores whatever title was there before on unmount.
 */
export function useDocumentTitle(title?: string | null): void {
  const previousTitle = useRef<string | null>(null);

  useEffect(() => {
    previousTitle.current = document.title;
    return () => {
      if (previousTitle.current !== null) document.title = previousTitle.current;
    };
  }, []);

  useEffect(() => {
    document.title = formatDocumentTitle(title);
  }, [title]);
}

export default useDocumentTitle;
